import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map,catchError  } from "rxjs/operators";
import { UserService } from '../services/user.service';
import { NavGuardService } from '../components/navigation/nav.gaurd.service';
import { PopupService } from '../core/popupmessage/popupmessage.service';


@Injectable()
export class AccessGuardService implements CanActivate{
    private lastUrl:string = "";
    
    constructor(
        private router:Router,
        private userServ: UserService,
        private popUp:PopupService,
        private navGuard:NavGuardService
    ){}

    canActivate(route: ActivatedRouteSnapshot, state:RouterStateSnapshot){
        console.log("AccessGuardService:checking CanActivate");
        this.lastUrl = state.url;
        let path = state.url.replace("/","");
        if(path === "unknown"){
            return true;
        }else{
            // let nodeName = this.userServ.getByAccessType("Lab");
            // if(nodeName == null){
            //     nodeName = [{name:""}];
            // }
            // if(nodeName.length === 1){
            //     this.popUp.ok("Page Not Found", "The Page Is Not Avliable","Please attempt to logout and login. If this issue contiues please contact your administrator for clearification.",3,true,[]);
            //     return false;
            // }

            // return this.userServ.checkStatus().pipe(map((response)=>{
            //     console.log(response);
            //     return false;
            // }))

            return this.userServ.checkStatus().then(()=>{
                return true;
            }).catch(()=>{
                this.userServ.logoutUser();
                this.router.navigate(['./login']);
                return false
            })

            // return this.userServ.userEvent("nodeNameGoesHere", "Checking Access","Navigating to Path: "+path).pipe(map(response =>{
            //     var data:any = response;
            //     if(Number(data.status) === 1){
            //         return true;
            //     } else if(Number(data.status) === 2){ 
            //         console.log(data.message);
            //         return true;
            //     }else if(Number(data.status) === 3){
            //         this.userServ.logoutUser();
            //         this.router.navigate(['./login']);
            //         return false
            //     }else if(Number(data.status) === 4){
            //         this.popUp.ok("Access Denied", "You Do Not Have Access","You do not have access to the page. if you feel this is not correct please contact your administrator for clearification.",3,true,[]);
            //         return false;
            //     }else if(Number(data.status) === 5){
            //         this.popUp.ok("User Limit Reached","","Other users are currently on the page. to get onto the page another user currently on the page will have to exit.",1,true,[]);
            //         return false
            //     }else{
            //         this.popUp.ok("Access Denied", "You Do Not Have Access","You do not have access to the page. if you feel this is not correct please contact your administrator for clearification.",3,true,[]);
            //         return false;
            //     }
            // }))
            // .catch(err =>{
            //     this.popUp.alertPopup("Error Detected", "Server Error Occured","If this continues please contact IT for support.",[]);
            //     return of(false);
            // })
            
        }
    }
}